<template>
    <v-select
            :value="value"
            v-on:input="updateValue($event)"
            :items="severityLevels"
            :label="label"
            :multiple="multiple"
            :attach="attach"
            :chips="chips"
            :disabled="disabled"
            :clearable="clearable"
    ></v-select>
</template>

<script>
    export default {
        name: 'SeveritySelector',
        props: {
            value: {},
            label: {type: String, default: "Severity"},
            multiple: {type: Boolean, default: false},
            chips: {type: Boolean, default: false},
            attach: {type: Boolean, default: false},
            clearable: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
        },

        data () {
            return {
                severityLevels:['low','medium','high','critical'],
            };
        },
        methods:{
            updateValue(value) {
                this.$emit('input', value)
            }
        }
    }
</script>